module.exports = __webpack_public_path__ + "img/darkBrown.aa70d617.svg";